@use '@/styles/tokens' as *;

/** Fieldset wrapper for the grouped range controls (Order Date Range, Order Amount,
 *  No of Devices). Mirrors FormField's vertical rhythm + label look so the groups line
 *  up with the MultiSelectFields above them. */
.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0 0 var(--space-4);
  padding: 0;
  border: 0;
}

.legend {
  padding: 0 var(--space-2);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

.row {
  display: flex;
  gap: var(--space-3);
}

.error {
  margin: 0;
  padding-inline: var(--space-2);
  font-size: 11px;
  font-weight: 300;
  color: $color-error-900;
}
